module.exports = __webpack_public_path__ + "assets/img/back-home-fragment.0f0edab7.png";